import { render, staticRenderFns } from "./GChatRightSidebar.vue?vue&type=template&id=8b07392a&scoped=true&"
import script from "./GChatRightSidebar.vue?vue&type=script&lang=js&"
export * from "./GChatRightSidebar.vue?vue&type=script&lang=js&"
import style0 from "./GChatRightSidebar.vue?vue&type=style&index=0&id=8b07392a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b07392a",
  null
  
)

export default component.exports